export type TDisplay = "default" | "mobileOnly" | "desktopOnly";

export const LOGO_DISPLAY_MAP: Record<TDisplay, string> = {
  default: "",
  mobileOnly: "lg:hidden",
  desktopOnly: "hidden lg:block",
};
